import Button from "@/components/base/Button";
import {
  ADDRESS_LINE_1,
  ADDRESS_LINE_2,
  DIRECTIONS_LINK,
  MAPS_LINK,
  MAP_EMBED_URL,
  WAZE_LINK,
} from "@/pages/home/constants";

const steps = [
  "Llega a la Plazoleta del Zócalo, en el centro de Guatapé.",
  "Entra al Museo del Zócalo.",
  "Busca el Local 408: vas a reconocerlo por los juegos de madera en la vitrina.",
];

export default function HowToGet() {
  return (
    <section id="como-llegar" className="w-full scroll-mt-24 bg-background-50">
      <div className="mx-auto w-full max-w-content px-4 py-16 md:px-6 md:py-24">
        <div className="reveal mx-auto mb-8 max-w-2xl text-center md:mb-12">
          <span className="text-xs font-label font-semibold uppercase tracking-[0.18em] text-accent-600">
            Guatapé, Antioquia
          </span>
          <h2 className="mt-3 text-3xl font-semibold md:text-[40px]">Cómo llegar al local</h2>
          <p className="mt-4 text-base text-foreground-600 md:text-lg">
            Estamos dentro del Museo del Zócalo, a pasos de la Plazoleta principal.
          </p>
        </div>

        <div className="reveal overflow-hidden rounded-2xl border border-background-200 bg-background-100">
          <iframe
            src={MAP_EMBED_URL}
            title="Mapa con la ubicación de Iokus Guatapé en el Museo del Zócalo"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="block h-[320px] w-full border-0 md:h-[420px]"
          ></iframe>
        </div>

        <div className="reveal mt-6 rounded-2xl border border-background-200 bg-background-100 p-5 md:mt-8 md:p-8">
          <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex items-start gap-4">
              <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-primary-100 text-primary-800">
                <i className="ri-map-pin-2-line text-xl" aria-hidden="true"></i>
              </span>
              <div>
                <p className="font-label text-xs font-semibold uppercase tracking-[0.14em] text-foreground-500">
                  Dirección
                </p>
                <p className="mt-1 text-lg font-semibold text-foreground-950">{ADDRESS_LINE_1}</p>
                <p className="text-base text-foreground-600">{ADDRESS_LINE_2}</p>
              </div>
            </div>

            <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap lg:justify-end">
              <Button
                href={MAPS_LINK}
                variant="primary"
                external
                fbEvent="FindLocation"
                fbLabel="google_maps"
              >
                <i className="ri-map-pin-line text-base" aria-hidden="true"></i>
                Abrir en Google Maps
              </Button>
              <Button
                href={DIRECTIONS_LINK}
                variant="outline"
                external
                fbEvent="FindLocation"
                fbLabel="navegacion"
              >
                <i className="ri-navigation-line text-base" aria-hidden="true"></i>
                Iniciar navegación
              </Button>
              <Button
                href={WAZE_LINK}
                variant="outline"
                external
                fbEvent="FindLocation"
                fbLabel="waze"
              >
                <i className="ri-route-line text-base" aria-hidden="true"></i>
                Abrir en Waze
              </Button>
            </div>
          </div>
        </div>

        <div className="reveal mt-6 grid gap-6 rounded-2xl bg-secondary-100/60 p-5 md:mt-8 md:grid-cols-2 md:gap-8 md:p-8">
          <div>
            <h3 className="text-xl font-semibold md:text-2xl">Si vienes caminando</h3>
            <p className="mt-2 text-sm text-foreground-600">
              Tres pasos y ya estás dentro del local.
            </p>
          </div>
          <ol className="space-y-4">
            {steps.map((step, index) => (
              <li key={step} className="flex items-start gap-3">
                <span className="flex h-7 w-7 flex-none items-center justify-center rounded-full bg-accent-500 text-sm font-bold text-background-50">
                  {index + 1}
                </span>
                <span className="text-sm leading-relaxed text-foreground-800 md:text-base">
                  {step}
                </span>
              </li>
            ))}
          </ol>
        </div>

        <p className="reveal mt-6 text-center text-sm text-foreground-600 md:text-base">
          <strong className="font-semibold text-foreground-900">¿Vienes desde Medellín?</strong>{" "}
          Son unas 2 horas por la vía Guatapé–El Peñol.
        </p>
      </div>
    </section>
  );
}